<template>
  <div class="studentifno-addstudent-upload">
    <!-- 上传模块 -->
    <div class="upload-module">
      <div class="module-title">上传XLSX表格</div>
      <el-upload :on-change="onChange" class="upload-demo" drag :show-file-list="false"
        action="https://jsonplaceholder.typicode.com/posts/" multiple :auto-upload="false" accept=".xls,.xlsx">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <!-- 预览模块 -->
    <div class="preview-module">
      <div class="module-title">预览</div>
      <div class="preview-table">
        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%; max-height: 300px; overflow-y: auto"
          :data="tableData">
          <el-table-column label="#" type="index"> </el-table-column>
          <el-table-column prop="studentName" label="姓名"> </el-table-column>
          <el-table-column prop="studentNumber" label="学号"> </el-table-column>
          <el-table-column prop="sex" label="性别"> </el-table-column>
          <el-table-column prop="duty" label="班级职务"> </el-table-column>
          <el-table-column prop="politicsStatus" label="政治面貌"> </el-table-column>
          <el-table-column prop="class" label="年级班级">
            {{ classData[0].gradeName + classData[1].className }}
          </el-table-column>
          <el-table-column label="家庭地址" :show-overflow-tooltip="true" prop="address">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 确认上传到服务器 -->
    <div class="confirm-module">
      <el-button type="primary" :loading="submitButtonLoading" @click="upload">{{
        submitButtonLoading ? "上传中" : "确认上传"
      }}</el-button>
      <!-- 下载模版 -->
      <el-button type="success" @click="uploadXlsxModule" v-hasPermi="'sc:student:add'">
        下载模版
      </el-button>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { baseURL } from "@/api/request";
export default {
  data() {
    return {
      submitButtonLoading: false,
      tableData: [],
      class: [],
    };
  },
  inject: ["standard"],
  props: {
    classData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    // 下载模板
    uploadXlsxModule() {
      window.open(`${baseURL}${this.$url.getStudentExport}`);
    },
    rimData(data) {
      return data.map(item => {
        const newItem = {};
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            // 如果值是字符串，则去除其首尾空格以及中间多余的空格
            if (typeof item[key] === 'string') {
              // 去除首尾空格
              let trimmedValue = item[key].trim();
              // 去除字符串内部多余空格
              trimmedValue = trimmedValue.replace(/\s+/g, ' ');
              newItem[key] = trimmedValue;
            } else {
              // 如果不是字符串，直接复制值
              newItem[key] = item[key];
            }
          }
        }
        return newItem;
      });
    },
    onChange(file, fileList) {
      // console.log(file);
      // console.log(fileList);
      let file_type = file.name.split(".")[1];
      if (!/^(xls|xlsx)$/g.test(file_type)) {
        return this.$message.error("只能选择xlsx或xls类型文件");
      } else {
        //是xlsx，xls文件,读取文件数据
        this.readFileData(file.raw, (workbook) => {
          this.readWorkbook(workbook);
        });
      }
    },
    readFileData(file) {
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          // console.log(ws);
          this.studentInfoPreviewTableInit(ws);
        } catch (e) {
          console.error(e);
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },
    studentInfoPreviewTableInit(unmodifiedTableData) {
      // console.log("unmodifiedTableData==>", unmodifiedTableData);
      this.tableData = [];
      unmodifiedTableData.forEach((item, index) => {
        let template = {};
        for (let standardItem of this.standard) {
          const value = item[standardItem.label];
          // 去除字符串字段的首尾空格和内部多余空格
          const trimmedValue = typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : value;
          template[standardItem.field] = trimmedValue;
        }
        this.tableData.push(JSON.parse(JSON.stringify(template)));
        // console.log(this.tableData);
      });
    },
    // 上传
    upload() {
      if (this.tableData.length == 0) {
        return this.$message.error("请添加数据");
      }
      if (this.submitButtonLoading) {
        return this.$message("上传中，请勿重复点击");
      }
      let { schoolId, schoolName } = this.user;
      let { gradeId, gradeName } = this.classData[0];
      let { classId, className } = this.classData[1];
      this.tableData.map((item) => {
        item.createBy = this.user.id;
        item.schoolId = schoolId;
        item.schoolName = schoolName;
        item.gradeId = gradeId;
        item.gradeName = gradeName;
        item.classId = classId;
        item.className = className;
      });
      // console.log(this.tableData);
      this.post(this.$url.insertStudentPC, this.tableData)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success("上传成功");
            this.$emit("uploadSuccess", res.data);
          } else {
            this.$message.error(res.msg);
          }
          this.submitButtonLoading = false;
        })
        .catch((err) => {
          this.submitButtonLoading = false;
          // this.$message.error("上传失败，请稍后再试");
        });
    },
    reset() {
      this.tableData = [];
    },
  },
};
</script>

<style scoped lang="scss">
@import "./studentifno-addstudent-upload.scss";
</style>
